
<template>
  <div class="menuSetting">
    <el-container>
      <el-aside style="width:420px;">
        <div class="menuTitlePanel">
          合作单位
          <!-- <el-button
            type="text"
            @click="addFirstSupplierType"
            v-if="btnAuthorize.addBtn.btnEnable"
          >新增一级分类</el-button> -->
          <img
            @click="delSupplierTypeInfo"
            src="@/assets/images/common/icon_delete.png"
            v-if="btnAuthorize.delBtn.btnEnable"
          />
          <img
            @click="updatesubSupplierType"
            src="@/assets/images/common/icon_modify.png"
            v-if="btnAuthorize.modifyBtn.btnEnable"
          />
          <img
            @click="addsubSupplierType"
            src="@/assets/images/common/icon_add.png"
            v-if="btnAuthorize.addBtn.btnEnable"
          />
        </div>
        <el-tree
          ref="deptTree"
          empty-text="暂无数据"
          :expand-on-click-node="true"
          :props="defaultTreeProps"
          :load="loadNode"
          node-key="id"
          @node-click="handleNodeClick"
          highlight-current
          lazy
        >
          <span class="treeNodeTxt" slot-scope="{ node }">
            <img class="treeNodeIcon" src="@/assets/images/common/icon_tree_node.png" />
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main>
        <div class="btnTitlePanel">分类信息</div>
        <div class="menuDetailPanel">
          <el-form :inline="true" :model="supplierDetail" class="form" label-width="150px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="分类名称">
                  <el-input v-model="supplierDetail.typeValue" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-main>
    </el-container>

    <!--新增分类-->
    <el-dialog
      class="maskBox"
      :visible.sync="isShowMaskBool"
      :title="dialogTitle"
      :close-on-click-modal="false"
    >
      <el-form
        id="addForm"
        :model="addForm"
        :rules="rules"
        inline
        ref="addForm"
        style="text-align: left;"
      >
        <el-row>
          <el-form-item label="名称" label-width="100px" prop="typeValue">
            <el-input class="titleSelect" v-model="addForm.typeValue" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-row>
        <!-- <el-row>
          <el-form-item label="状态" label-width="180px">
            <el-select v-model="addForm.status" disabled>
              <el-option
                :label="state.statusName"
                :value="state.status"
                v-for="state in statusList"
                :key="state.status"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeBtn">取 消</el-button>
        <el-button type="primary" @click="updateBtn" v-show="isShowMaskBox==2">修改</el-button>
        <el-button type="primary" @click="saveaddBtn" v-show="isShowMaskBox==1">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierTypeList, //获取供应商一级类别列表接口
  getSuppliersubTypeList, //查询子类别列表接口
  saveSupplierTypeInfo, //新建供应商类别
  updateSupplierTypeInfo, //更新供应商类别
  delSupplierTypeInfo //删除供应商类别
} from "../../services/supplierMagServices";

export default {
  name: "approvePostSetting",
  props: {
    menuCode: {
      type: String
    }
  },
  data() {
    return {
      isShowMaskBool: false,
      isShowMaskBox: 1,
      dialogTitle: "新增一级分类",
      addForm: {
        typeValue: "", //分类名称
        level: 0, //类型等级
        parentId: 0 //父类型Id
      },
      supplierDetail: {
        typeValue: "", //分类名称
        level: 0, //类型等级
        parentId: 0 //父类型Id
      },
      ChangeName: true,
      selectedNode: {}, //记录选中节点数据
      node: [],
      resolve: [],
      //状态列表
      statusList: [
        { statusName: "禁用", status: 0 },
        { statusName: "启用", status: 1 }
      ],
      rules: {
        typeValue: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 40, message: "长度在 1 到 40 个字符", trigger: "blur" }
        ]
      },
      formInline: {
        name: ""
      },
      page: 1,
      rows: 10,
      total: null,
      tableData: [],
      GovList: [], //组织列表
      subDeptList: [], //子部门列表
      defaultTreeProps: {
        id: "id",
        label: "typeValue",
        isLeaf: "leaf",
        children: "subList"
      },
      selectTableItem: null,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false }
      }
    };
  },

  methods: {
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.matchedName = "";
    },
    // 加载树结点
    loadNode(node, resolve) {
      this.node = node;
      this.resolve = resolve;
      // 如果是顶级的父节点
      if (node.level === 0) {
        let reqParam = {
          pageIndex: "1",
          pageSize: "50"
        };
        getSupplierTypeList().then(
          res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.level = 1;
              });
              return resolve(nodes);
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            }
          },
          err => {
            this.$message.error("系统异常");
          }
        );
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.supplierTypeId = node.data.id;
        getSuppliersubTypeList(param)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.leaf = item.isLeaf == 1;
              });
              return resolve(nodes);
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      }
    },
    /* 菜单点击回调事件 */
    handleNodeClick(Node) {
      if (Node.level >= 1) {
        //选中的一级分类
        this.ChangeName = false;
        this.supplierDetail = { ...Node };
        this.selectedNode = Node;
      } else {
        this.ChangeName = true;
        this.selectedNode = Node;
        this.supplierDetail.typeValue = Node.typeValue;
        // this.supplierDetail.level = 1;
        // this.supplierDetail.parentId = 0;
      }
      // this.$set()
    },
    /* 按钮点击回调事件 */
    menuBtnClick(btn) {
      this.btnSelected = btn.id;
    },

    //新增一级供应商分类
    addFirstSupplierType() {
      this.isShowMaskBox = 1;
      this.dialogTitle = "新增一级分类";
      this.isShowMaskBool = true;
      this.addForm = {
        typeValue: "", //分类名称
        level: 1, //类型等级
        parentId: 0 //父类型Id
      };

      if (this.selectedNode.level == 1) {
        // this.addForm.orgId = this.selectedNode.id;
      } else {
        // this.addForm.parentId = this.selectedNode.id;
        // this.addForm.orgId = this.selectedNode.orgId;
      }
    },
    /* 菜单新增按钮回调 */
    addsubSupplierType() {
      var arr = Object.keys(this.selectedNode);
      if (arr.length <= 0) {
        this.$alert("请选择一级分类", "提示");
        return;
      }
      if (this.selectedNode.level >= 3) {
        this.$alert("只支持三级分类", "提示");
        return;
      }
      // if (this.deptSelected.id != this.deptSelected.pid) {
      //   this.$alert("最多只能创建二级公司", "提示");
      //   return;
      // }
      this.isShowMaskBox = 1;
      this.dialogTitle = "新增下级分类";
      this.isShowMaskBool = true;
      this.addForm = {
        typeValue: "", //分类名称
        level: 1, //类型等级
        parentId: 0 //父类型Id
      };
      this.addForm.parentId = this.selectedNode.id;
      this.addForm.level = this.selectedNode.level + 1;
    },
    /* 菜单修改按钮回调 */
    updatesubSupplierType() {
      var arr = Object.keys(this.selectedNode);
      if (arr.length <= 1) {
        this.$alert("请选择分类", "提示");
        return;
      }
      if (this.selectedNode.level == 1) {
        this.dialogTitle = "修改一级分类";
      } else {
        this.dialogTitle = "修改下级分类";
      }

      let reqParam = {
        id: this.selectedNode.id
      };
      this.addForm.level = this.selectedNode.level;
      this.addForm.parentId = this.selectedNode.parentId;
      this.addForm.typeValue = this.selectedNode.typeValue;
      this.addForm.id = this.selectedNode.id;

      this.isShowMaskBox = 2;
      this.isShowMaskBool = true;
    },

    /* 菜单删除按钮回调 */
    delSupplierTypeInfo() {
      let _this = this;
      if (this.selectedNode.level > 0) {
        this.$confirm("确定删除该分类?", "提示", {
          confirmButtonText: "确认"
        }).then(() => {
          let reqParam = {
            supplierTypeId: _this.selectedNode.id
          };
          delSupplierTypeInfo(reqParam).then(
            res => {
              if (res.code == 10000000) {
                _this.$alert("删除成功", "提示", {
                  confirmButtonText: "确定"
                });
                _this.node.parent.loaded = false;
                _this.node.parent.expand();
                _this.loadNode(_this.node, _this.resolve);
              } else {
                _this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        });
      } else if (this.selectedNode.level == 1) {
        this.$alert("不能删除一级分类", "提示", {
          confirmButtonText: "确认"
        });
      } else {
        this.$alert("请选择要删除的分类", "提示", {
          confirmButtonText: "确认"
        });
      }
    },
    saveaddBtn() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let reqParam = {
            typeValue: this.addForm.typeValue,
            parentId: this.addForm.parentId,
            level: this.addForm.level
          };
          saveSupplierTypeInfo(reqParam).then(
            res => {
              if (res.code == 10000000) {
                this.$alert("新增成功", "提示", {
                  confirmButtonText: "确定"
                });
                this.closeBtn();
                let currentNode = this.$refs.deptTree.getCurrentNode();
                 let currentNodeIns={};
                  
                 if (this.addForm.level == 1) {
                   currentNodeIns = this.$refs.deptTree.getNode(1);
                } else{
                  currentNodeIns = this.$refs.deptTree.getNode(
                    currentNode.id);
                }
                let parentNode = currentNodeIns.parent;
                parentNode.expanded = false;
                parentNode.loaded = false;
                parentNode.expand();

                // this.loadNode(this.node, this.resolve);
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateBtn() {
      let _this = this;
      if (this.amendLoading) {
        return;
      }
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          _this.amendLoading = true;
          let reqParam = {
            id: _this.selectedNode.id,
            typeValue: _this.addForm.typeValue,
            parentId: _this.selectedNode.parentId,
            level: _this.selectedNode.level
          };

          updateSupplierTypeInfo(reqParam).then(
            res => {
              if (res.code == 10000000) {
                _this.$alert("修改成功", "提示", {
                  confirmButtonText: "确定"
                });               
                _this.closeBtn();
                let currentNode = _this.$refs.deptTree.getCurrentNode();
                let currentNodeIns = _this.$refs.deptTree.getNode(
                  currentNode.id
                );
                let parentNode = currentNodeIns.parent;
                parentNode.expanded = false;
                parentNode.loaded = false;
                parentNode.expand();
                // _this.loadNode(_this.node,_this.resolve);
              } else {
                _this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              _this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        }
      });
    },
    closeBtn() {
      this.amendLoading = false;
      this.isShowMaskBool = false;
      this.addForm.name = "";
      this.addForm.sort = "";
    },
    /* 菜单修改-保存按钮回调 */
    menuSave() {
      if (this.isAddMenu) {
        this.addMenuReq();
      } else {
        this.modifyMenuReq();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menuSetting {
  height: 100%;
  background-color: #e9f4fa;
  .el-container {
    height: 100%;
    .el-aside {
      padding: 24px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      .el-tree {
        background-color: #f0f5f7;
        overflow: auto;
        height: 100%;
      }
    }
  }
  /deep/.el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
  /deep/.el-dialog {
    width: 28%;
  }
}
.menuDetailPanel {
  text-align: left;
  min-height: 120px;
  padding: 16px 0 0 0;
}
.menuTitlePanel {
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 16px;
  img {
    vertical-align: bottom;
    float: right;
    margin: 12px 8px 0 0;
  }
  .el-button {
    margin-left: 120px;
  }
}
/deep/.el-input__inner {
  width: 320px;
}
.btnTitlePanel {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  background-color: #edf8fa;
  padding: 16px;
  margin-bottom: 16px;
}
.el-main {
  margin-left: 16px;
  background-color: #fff;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.operatePanel {
  text-align: right;
  margin: 16px 0;
  padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.addDialog/deep/.el-dialog {
  width: 30%;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
